<template>
  <v-card
    data-cy="overview-card"
    flat
    tile
  >
    <v-card-title class="tab-title d-flex">
      <v-btn
        v-if="showProviderProfileNavBtn"
        @click="emit('toggleProviderProfileNav')"
        :aria-label="$bct('Toggle provider profile navigation')"
        data-cy="provider_profile_nav_icon"
        icon="menu_open"
        variant="text"
      />
      <h2 class="v-card-title py-0 px-0 d-flex align-center">
        {{ $bct('Overview') }}
      </h2>
    </v-card-title>

    <v-divider />

    <v-card-text class="py-4">
      <template v-if="provider.published">
        <p class="mb-3">
          {{ $bct('Your profile is published!') }}
        </p>
        <v-btn
          @click="togglePublished"
          :loading="processing"
          color="primary"
          data-cy="unpublish-button"
          variant="outlined"
        >
          {{ $bct('Unpublish') }}
        </v-btn>
      </template>
      <template v-else>
        <p class="mb-3">
          {{ $bct('Your profile is not published') }}
        </p>
        <v-btn
          @click="togglePublished"
          :loading="processing"
          color="primary"
          data-cy="publish-button"
        >
          {{ $bct('Publish') }}
        </v-btn>
      </template>
    </v-card-text>
  </v-card>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  provider: {
    type: Object,
    required: true,
  },
  processing: {
    type: Boolean,
    default: false,
  },
  showProviderProfileNavBtn: {
    type: Boolean,
    default: null,
  },
});

const emit = defineEmits(['change:publish', 'toggleProviderProfileNav']);

const togglePublished = () => {
  emit('change:publish', !props.provider.published);
};
</script>
